import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_MOVIE_PUBLISH_PAGE, LOAD_SEO } from '../protocols';
export interface State {
    albums: MovieAlbum[],
}

class MoviePublish extends BaseModule<State>{
    constructor() {
        super(LOAD_MOVIE_PUBLISH_PAGE[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                albums: [],
            },
            mutations: {
                updateAlbums(state, data) {
                    state.albums = data;
                }
            },
            actions: {
                async loadData({ commit }) {
                    let { data } = await api.getMovieAlbums({ addtimeOrder: 'DESC', page: 1, limit: 100 })
                    commit('updateAlbums', data)
                },
                [LOAD_MOVIE_PUBLISH_PAGE[1]]({ dispatch }) {
                    return Promise.all([
                        dispatch('loadData'),
                        dispatch(LOAD_SEO, { file: 'publish' }, { root: true })
                    ])
                }
            }
        }
    }
}

export default new MoviePublish();